export default __webpack_public_path__ + "static/AN_Loop_opt-21ec29e021b5ca1042e3121dee81e58d.mp4";